<template>
  <div class="home-child-wrapper friend-container">
    <el-container>
      <el-main>
        <div class="edit-article-container">
          <EditArticle :editScene="editScene" />
        </div>
        <div class="feed-container" v-loading="feedShade">
          <FeedItem v-for="feed in feedList" :key="feed.modelId" :feed="feed" />
          <div class="without-content-wrap" v-show="withoutFeed">
            <img
              class="cl-without-content"
              src="../assets/icon/cl_without_content.png"
            />
            <p>暂无内容</p>
          </div>
        </div>
        <ShareHandLian />
        <PhotoPreviewer />
        <AvatarPreviewer />
      </el-main>
      <el-aside width="340px">
        <div class="right-aside">
          <div class="profile-wrapper">
            <UserProfile :profile="userProfile" :profileMenu="profileMenu" />
          </div>
        </div>
      </el-aside>
    </el-container>
    <div class="message-aside">
      <MessageMenu />
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { apiMap } from "../utils/apiMap";
import EditArticle from "../components/user/edit-article";
import UserProfile from "../components/UserProfile";
import PhotoPreviewer from "../components/PhotoPreviewer";
import AvatarPreviewer from "../components/AvatarPreviewer";
import FeedItem from "../components/friend/feed-item";
import MessageMenu from "../components/message-aside/message-menu";
import ShareHandLian from "../components/ShareHandLian";
import { reviewTime } from "../utils/date";
export default {
  name: "feeds",
  data() {
    return {
      feedShade: true,
      onFetching: false,
      withoutFeed: false,
      feedList: [],
      feedPage: 1,
      profileMenu: {
        linkBtn: true,
        addFriendBtn: false,
        copyTreeBtn: false,
        modifyTreeBrn: false,
        apllyTreeBtn: false,
      },
      editScene: "friendFeed",
    };
  },
  components: {
    EditArticle,
    FeedItem,
    PhotoPreviewer,
    AvatarPreviewer,
    UserProfile,
    MessageMenu,
    ShareHandLian,
  },
  computed: {
    ...mapGetters([
      "userProfile",
      "conversationList",
      "currentConversation",
      "contactsList",
      "croupsList",
      "commentList",
    ]),
  },
  beforeMount() {
    this.getFriendFeed();
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    this.$bus.$on("update-feed-list", this.updateFeedList);
    this.$bus.$on("unshare-friend-feed", this.unShareFeedOnFriend);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    getFriendFeed() {
      let _this = this;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      let params = `token=${loginUser.token}&start=${this.feedPage}&count=10`;
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["friendFeed"]["method"],
          url: apiMap["friendFeed"]["url"],
          data: params,
          timeout: 4000,
        })
        .then(function (response) {
          _this.feedShade = false;
          if (response.data.result.statusCode == 1) {
            let friendFeed = response.data.result.data;
            if (friendFeed.length == 0) {
              _this.$message({
                message: "暂无数据",
              });
              _this.onFetching = true;
              return false;
            }
            for (let index = 0; index < friendFeed.length; index++) {
              const element = friendFeed[index];
              //过滤音频 和 视频 和未通过审核的动态
              if (element.article == 3 || element.article == 4) {
                continue;
              }
              var diffTime =
                response.data.result.requestTime - element.created_at;
              var reviewStatus = diffTime > reviewTime ? "pass" : "fail";
              if (reviewStatus == "pass") {
                _this.feedList.push(element);
              }
            }
            if (response.data.result.data.length == 0) {
              _this.$message({
                message: "数据加载完啦，请浏览其他内容",
              });
              _this.onFetching = true;
            }
          } else {
            if (response.data.result.count == 0) {
              _this.$message({
                message: "暂无动态，请浏览其他内容",
              });
              _this.onFetching = true;
              _this.withoutFeed = true;
            } else {
              if (response.data.result.data.length == 0) {
                _this.$message({
                  message: "数据加载完啦，请浏览其他内容",
                });
                _this.onFetching = true;
              }
            }
          }
        })
        .catch(function (error) {
          if (error.message.includes("timeout")) {
            _this.$message({
              message: "获取小区动态超时",
            });
          } else {
            _this.$message({
              message: "获取小区动态出错",
              type: "warning",
            });
          }
        });
    },
    updateFeedList() {
      this.feedList = [];
      this.feedShade = true;
      this.onFetching = false;
      this.feedPage = 1;
      this.getFriendFeed();
    },
    unShareFeedOnFriend(feedID, feedType) {
      let _this = this;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      let requestUrl = "";
      let method = "";
      let params = "";
      switch (feedType) {
        case 1:
          requestUrl = apiMap["articleShare"]["url"];
          method = apiMap["articleShare"]["method"];
          params = `token=${loginUser.token}&articleId=${feedID}&shareField=shareFriends&shareValue=0`;
          break;
        case 2:
          requestUrl = apiMap["albumShare"]["url"];
          method = apiMap["albumShare"]["method"];
          params = `token=${loginUser.token}&photoId=${feedID}&shareField=shareFriends&shareValue=0`;
          break;
        case 3:
          requestUrl = apiMap["musicShare"]["url"];
          method = apiMap["musicShare"]["method"];
          params = `token=${loginUser.token}&musicId=${feedID}&shareField=shareFriends&shareValue=0`;
          break;
        case 4:
          requestUrl = apiMap["videoShare"]["url"];
          method = apiMap["videoShare"]["method"];
          params = `token=${loginUser.token}&videoId=${feedID}&shareField=shareFriends&shareValue=0`;
          break;
      }
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: method,
          url: requestUrl,
          data: params,
        })
        .then(function (response) {
          if (response.data.result.statusCode == 1) {
            var findIndex = -1;
            _this.feedList.filter((item, index) => {
              if (item.modelId == feedID && item.article == feedType) {
                findIndex = index;
              }
            });
            if (findIndex != -1) {
              _this.feedList.splice(findIndex, 1);
              _this.$message({
                message: "操作成功！",
                type: "success",
              });
            }
          } else {
            _this.$message({
              message: "操作失败，稍后再试",
              type: "warning",
            });
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    handleScroll() {
      var scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      var windowHeight =
        document.documentElement.clientHeight || document.body.clientHeight;
      var scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;
      if (this.onFetching) {
      } else {
        if (windowHeight >= scrollHeight - scrollTop - 5) {
          this.onFetching = true;
          setTimeout(() => {
            this.feedPage += 1;
            this.getFriendFeed();
            this.onFetching = false;
          }, 500);
        }
      }
    },
  },
};
</script>
<style scoped>
.edit-article-container {
  width: 840px;
  padding: 10px 15px;
  margin-bottom: 10px;
  box-sizing: border-box;
  background-color: #fff;
}

.feed-container {
  width: 840px;
  min-height: 232px;
}

.right-aside {
  position: fixed;
  width: 340px;
}

.right-aside .profile-wrapper {
  background-color: #fff;
}

.without-content-wrap {
  height: 750px;
  text-align: center;
  color: #999;
  background-color: #fff;
}

.cl-without-content {
  width: 200px;
  margin: 30px 0 15px;
}
</style>